import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  set ({ params: { string } }) {
    document.cookie = string
  }
}
